<script>
import { getShadowColor } from '@/utils/modules/getStyles'
import { filePathFn } from '@/utils/common'

export default {
  name: 'AudioPlayer',
  props: {
    audiourl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    publisher: {
      type: String,
      default: ''
    },
    idx: {
      type: Number,
      default: 0
    },
    isplaying: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      path: this.$route.path,
      totalTime: 0,
      currentTime: 0
    }
  },
  computed: {
    audioFullPath() {
      return filePathFn(this.audiourl) // `${baseURL}/Video/${this.audiourl}`
    },
    formatTotalTime() {
      return this.formatTime(this.totalTime)
    },
    formatCurrentTime() {
      return this.formatTime(this.currentTime)
    },
    operationLogo() {
      return this.isplaying ? require('imgs/modules/playing.png') : require('imgs/modules/pause.png')
    }
  },
  watch: {
    isplaying: {
      handler: function(newVal) {
        this.$nextTick(() => {
          newVal ? this.$refs.audio.play() : this.$refs.audio.pause()
        })
      },
      immediate: true
    }
  },
  mounted() {
    // audioGroup
    // console.log('fa audio ref', this.$parent.$refs['audioGroup'][this.idx].$refs)
    this.$refs.audio.src = this.audioFullPath
    // 将range位置归0, 如果不使用这个的话, 设置了value之后没有用
    setTimeout(() => {
      this.$refs.range.value = 0
    }, 1)
  },
  methods: {
    getShadowColor,
    onAudioClick() {
      const audio = this.$refs.audio
      const audioList = this.$parent.$refs['audioGroup']
      this.isplaying ? audio.pause() : audio.play()
      // this.isPlay = !this.isPlay
      this.$emit('handleAudioClick', this.idx)
      audioList.forEach(item => {
        if (item.$refs.audio.className !== this.$refs.audio.className) item.$refs.audio.pause()
      })
    },
    loadingFinish() {
      const totalTime = this.$refs.audio.duration
      this.totalTime = totalTime
    },
    // range--拖动进度条得到的回调
    onChange() {
      let value = this.$refs.range.value
      const persentage = ((value / 360) * 100).toFixed(1) + '%'
      this.$refs.range.style.backgroundSize = `${persentage} 100%`
      // 控制音频播放
      const timeToGo = (value / 360) * this.totalTime
      const audio = this.$refs.audio
      audio.currentTime = timeToGo
    },
    // audio--进度变化的时候的回调--改变文字
    update() {
      const audio = this.$refs.audio
      if (!audio) return
      const currentTime = audio.currentTime || 0 // 当前播放时间
      this.currentTime = currentTime
      // 改变进度条的值
      const range = this.$refs.range
      range.value = ((this.currentTime / this.totalTime) * 360).toFixed(1)
      // 进度条的值改变的时候，颜色也跟着变化
      const persentage = ((this.currentTime / this.totalTime) * 100).toFixed(1) + '%'
      this.$refs.range.style.backgroundSize = `${persentage} 100%`
    },
    formatTime(value) {
      let second = 0
      let minute = 0
      minute = parseInt(value / 60)
      second = parseInt(value % 60)
      minute = minute < 10 ? `0${minute}` : minute
      second = second < 10 ? `0${second}` : second
      return `${minute}:${second}`
    }
  }
}
</script>

<template>
  <div class="audio-player-container">
    <div class="audio-container" :style="{boxShadow: `0 3px 10px 0 ${getShadowColor}`}">
      <el-image
        class="audio-logo"
        :class="{'audio-animation': isplaying}"
        :src="require('imgs/modules/audio-logo.png')"
        alt="audio-logo"
      />

      <div class="right-main">
        <div class="main-content">
          <div class="audio-msg">
            <p class="audio-title h-line-1">{{ title || "未知" }}</p>
            <div class="audio-time-box">
              <p v-if="publisher" class="audio-source">来源 -- {{ publisher || '暂无' }}</p>
              <p v-if="publisher" class="gap">|</p>
              <p class="audio-time">时长: {{ formatTotalTime }}</p>
            </div>
          </div>

          <el-image
            :src="operationLogo"
            class="operation-logo pointer"
            @click.stop="onAudioClick"
          />
        </div>

        <div v-show="isplaying" class="progress">
          <input ref="range" type="range" min="0" max="360" value="0" @input="onChange" @change="onChange">
        </div>
      </div>
    </div>
    <audio
      ref="audio"
      style="display: none"
      :class="`audio-comp-${idx}`"
      :src="audioFullPath"
      controls
      @timeupdate="update"
      @canplay="loadingFinish"
    />
  </div>
</template>

<style lang="scss" scoped>
@keyframes audio-logo-rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.audio-container {
  width: 450px;
  min-height: 84px;
  padding: 20px 25px;
  box-sizing: border-box;
  background: url('~imgs/modules/module-66-bg.png') no-repeat center;
  background-size: 100% 100%;
  background-color: #FFE4E2;
  box-shadow: 0px 4px 15px 0px rgba(23,23,23,0.1);
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  position: relative;
  .audio-logo {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 26px;
    height: 26px;
  }
  .audio-animation {
    animation: audio-logo-rotate 6s linear infinite;
  }
}
.right-main {
  width: 340px;
  display: flex;
  flex-direction: column;
  .main-content {
    width: 340px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 45px;
  }
  .audio-msg {
    width: 100%;
    // height: 45px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .audio-title {
      font-size: 17px;
      font-weight: 800;
      color: #040000;
    }
  }
  .operation-logo {
    width: 17px;
    height: 21px;
  }
  .audio-time-box {
    display: flex;
    align-items: flex-start;
    width: 310px;
    font-size: 14px;
    font-weight: 600;
    color: #999;
    margin-top: 6px;
    .gap {
      font-weight: normal;
      padding: 0 12px;
    }
    .audio-time {
      width: 45%;
    }
  }
}
.progress {
  margin: 20px 0 0 15px;
}

// 控件
input[type='range'] {
  outline: none;
  -webkit-appearance: none; /*清除系统默认样式*/
  width: 322px !important;
  background: -webkit-linear-gradient(#FF444D, #FF444D) no-repeat, #FFDADB; /*背景颜色，俩个颜色分别对应上下*/
  background-size: 0% 100%; /*设置左右宽度比例，这里可以设置为拖动条属性*/
  height: 3px;
  border-radius: 2px;
}
/*拖动块的样式*/
input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none; /*清除系统默认样式*/
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: #FF444D; /*拖动块背景*/
}
</style>
